import type {
  IUpdateUserCustomInstructionsPayload,
  IUserCustomInstructionsView,
} from "../types/user-custom-instructions";
import type { ApiClient } from "./client";

export class UserCustomInstructionsApi {
  constructor(private apiClient: ApiClient) {}

  // NOTE: The endpoint returns null (not 404) when the user has never saved
  // memory instructions, so the caller can render an empty editor without
  // treating a first visit as an error.
  async get(): Promise<IUserCustomInstructionsView | null> {
    const response =
      await this.apiClient.get<IUserCustomInstructionsView | null>(
        "/user/custom-instructions",
      );
    return response.data;
  }

  async upsert(
    payload: IUpdateUserCustomInstructionsPayload,
  ): Promise<IUserCustomInstructionsView> {
    const response = await this.apiClient.put<IUserCustomInstructionsView>(
      "/user/custom-instructions",
      payload,
    );
    return response.data;
  }

  async clear(): Promise<void> {
    await this.apiClient.delete("/user/custom-instructions");
  }
}
